export default __webpack_public_path__ + "static/media/menu-tile-relationships.4da5af34.png";